define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Container"
], function(declare,_,Container) {

	return declare(Container, {
		type: "stringlist",
		
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported
			return null;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return keys for nested views if they exist - otherwise output headings
			var	node = ctx.getNode();
			var	keys = _.keys(node.NestedViews || {});
			if (keys.length) {
				return keys;
			}
			
			return _.values(node.Keys).sort();
		}
	});
});